import axios from 'axios'


const instance = axios.create(
    {
        baseURL: "https://api.tg-app.pl",
        
    }
);

instance.defaults.timeout = 240000;

export default instance;